import { ApplicationRef, Component, Inject, Input, PLATFORM_ID, ViewChild } from '@angular/core';
import { KlaDataService } from './shared/tools/services/kla.data.service';
import { KlaHttpService } from './shared/tools/services/kla.http.service';
import { CustomScript, CustomStyle } from './shared/tools/services/kla.data.models';
import { Router, RouterModule } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from './shared/services/data.service';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ScriptComponent } from './shared/tools/script/script.component';
import { AnalyticsComponent } from './core/analytics/analytics.component';
import { HotjarComponent } from './core/hotjar/hotjar.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LightboxModule } from 'ngx-lightbox';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ScriptComponent,
    AnalyticsComponent,
    HotjarComponent,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    LightboxModule
  ]
})
export class AppComponent {
  subscription: {
    type: 'success' | 'error',
  };
  lastPoppedUrl: string;
  yScrollStack: number[] = [];
  @ViewChild('modal', {static: true}) modal;

  @Input() faviconElement: any;

  customScripts;

  data: any;
  isPreview = false;
  isLoading = true;
  _reload = true;

  constructor(
    private dataService: KlaDataService,
    private router: Router,
    private modalService: NgbModal,
    private httpService: KlaHttpService,
    private dataService2: DataService,
    private aprf: ApplicationRef,
    @Inject(PLATFORM_ID) private platformId
  ) {
    const id = DataService.getData().website_id;
    if(isPlatformBrowser(this.platformId)) {
      if (id) {
        this.httpService.checkIsMaintenance(id).subscribe((response: any) => {
          DataService.isMaintenance = !!response.maintenance_mode;
          DataService.maintenanceDescription = response.maintenance_description;
          if (DataService.isMaintenance) {
            this.router.navigate(['/maintenance']).then();
          }
        });
      }
     }
    this.loadData();
    if (window.opener) {
      window.opener.postMessage('started', '*');
      window.addEventListener('message', ($event) => {
        if (($event.origin.includes('localhost') || $event.origin.includes('admin-kla-')) && !$event.data.type) {
          this.isPreview = true;
          this.dataService2.getDataFromBackend($event);
          setTimeout(() => {
            this._reload = false;
          });
          setTimeout(() => {
            this._reload = true;
          }, 500);
          this.loadData();
        }
      });
    }
  }

  public loadData() {
    this.data = this.dataService.getData();

    if (this.isDataEmpty(this.data)) {
      return;
    }
    this.isLoading = false;

    const defaultPage = this.isPreview ? this.data.defaultPageUrl : this.data.default.defaultPageUrl;
    const customScripts = this.isPreview ? this.data.customScripts : this.data.default.customScripts;
    if (customScripts) {
      //this.insertCustomScripts(customScripts);
    }
    const customStyles = this.data.customStyles;
    if (customStyles) {
      this.insertCustomStyles(customStyles);
    }
    const path = window.location.pathname;
    if (path && !DataService.isMaintenance) {
      if (defaultPage && (path == '' || path == '/')) {
        this.router.navigateByUrl(defaultPage).then();
      } else if (!defaultPage && (path == '' || path == '/')) {
        this.router.navigateByUrl('/' + DataService.DEFAULT_PAGE_URL).then();
      }
      if (this.isPreview) {
        this.router.navigateByUrl('/' + DataService.DEFAULT_PAGE_URL).then();
        return;
      }
    }
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        this.setFavicon();
        document.title = DataService.getData().name;
        if (DataService.isLivePreview) {
          document.title = 'Preview site';
        }
      }, 500);
    }
  }

  private isDataEmpty(obj) {
    if (obj === null) {
      return true;
    }
    if (obj.default) {
      for (const key in obj.default) {
        if (obj.default.hasOwnProperty(key)) {
          return false;
        }
      }
    } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          return false;
        }
      }
    }
    return true;
  }


  private insertCustomScripts(customScripts: Array<CustomScript>) {
    customScripts.forEach((script: CustomScript) => {
      if (script && script.script) {
        let element: any = document.createElement('div');
        script.script = script.script.trim();
        if (script.script.indexOf('<script') == 0) {
          let temp: any = document.createElement('div');
          temp.innerHTML = script.script;
          script.script = temp?.firstChild.innerHTML;
        }
        const object = document.createElement('script');
        object.innerHTML = script.script;
        element.appendChild(object);
        if (script.position == 'head') {
          document.head.appendChild(element?.firstChild);
        } else {
          document.body.appendChild(element?.firstChild);
        }
      }
    });
  }

  private insertCustomStyles(customStyles: Array<CustomStyle>) {
    customStyles.forEach((item: CustomStyle) => {
      if (item && item.style) {
        let element: any = document.createElement('div');
        item.style = item.style.trim();
        if (item.style.indexOf('<style') == 0) {
          let temp: any = document.createElement('div');
          temp.innerHTML = item.style;
          item.style = temp.firstChild.innerHTML;
        }
        const object = document.createElement('style');
        object.innerHTML = item.style;
        element.appendChild(object);
        if (item.position == 'head') {
          document.head.appendChild(element?.firstChild);
        } else {
          document.body.appendChild(element?.firstChild);
        }
      }
    });
  }

  private setFavicon() {
    const favicon = this.dataService.getData().default ?
      this.dataService.getData().default.favicon :
      this.dataService.getData().favicon;

    if (!favicon || favicon.image == 'null') {
      console.error('Failed to load favicon.', favicon);
      return false;
    }

    const faviconElement = document.getElementById('favicon-link') as any;
    faviconElement.href = this.getFaviconUrl();
  }

  private getFaviconUrl() {
    const favicon = this.data.favicon;
    const imageConfig = {
      id: favicon.image,
      width: 50,
      height: undefined,
      cropConfig: favicon.crop_config
    };
    return this.httpService.getCroppedImagePath(imageConfig);
  }

}
